import { h, Component } from "preact";
import EventTilesView from "./EventTilesView";
import EventImageListView from "./EventImageListView";
import EventDateListView from "./EventDateListView";
import { css } from "emotion";

/**
 * Display event list of tour page
 *
 * @param {*} props
 * @returns
 */
const Events = props => {
  const {
    events,
    pageLayout,
    listViewType,
    theme,
    showPrice,
    eventListingLayout
  } = props;
  const styles = {
    wrapper: css`
      display: ${pageLayout === "tiles" ? "flex" : "inherit"};
      flex-wrap: wrap;
      margin-left: auto;
      margin-right: auto;
      @media (max-width: 1000px) {
        justify-content: center;
      }
      @media (max-width: 600px) {
        display: inherit;
      }
    `
  };
  let ReturnComponent = EventTilesView;
  ReturnComponent =
    pageLayout === "list" && listViewType == "image"
      ? EventImageListView
      : ReturnComponent;
  ReturnComponent =
    pageLayout === "list" && listViewType == "date"
      ? EventDateListView
      : ReturnComponent;
  return (
    <div className={styles.wrapper}>
      {events.map((event, index) => {
        // used in EventTilesView
        const noRightMargin = (index + 1) % 3 === 0;
        // used in EventDateListView
        const noBottomBorder = events.length === index + 1;
        return (
          <ReturnComponent
            event={event}
            featured={true}
            theme={theme}
            noRightMargin={noRightMargin}
            showPrice={showPrice}
            eventListingLayout={eventListingLayout}
            noBottomBorder={noBottomBorder}
          />
        );
      })}
    </div>
  );
};

export default Events;



// WEBPACK FOOTER //
// ./routes/tours/Events.js